import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ProgramPodViewComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;

  private static readonly POD_GROUP_IDS = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];

  private groupKeys: any;
  private isSaveAvailable: boolean;
  private groupKeysCopy: any;

  constructor(private PricePlanService) {
  }

  $onInit() {
    this.setGroupKeys();
  }

  onPodChange(pod, purpose) {
    this._sanitizePodLink(pod);
    this.onDataChange(this.groupKeys);
  }

  onSaveProgram() {
    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
      })
      .catch(() => {

      })
      .finally(() => {
        this.setGroupKeys();
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private setGroupKeys() {
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this._sanitizeLinkedPods(this.groupKeys);
    this.groupKeysCopy = angular.copy(this.groupKeys);
  }

  private onDataChange(groupKeys) {
    this.isSaveAvailable = !_.isEqual(groupKeys, this.groupKeysCopy);
  }

  // When a POD is "linked to parent" (pod.value === undefined), `isFillRequired`
  // has no meaning locally — strip it so the payload stays clean. Also guards
  // against buggy backend data where isFillRequired is still set on a linked POD.
  private _sanitizeLinkedPods(groupKeys) {
    _.forEach(ProgramPodViewComponent.POD_GROUP_IDS, (groupId) => {
      _.forOwn(_.get(groupKeys, groupId), (pod) => this._sanitizePodLink(pod));
    });
  }

  private _sanitizePodLink(pod) {
    if (pod && _.isUndefined(pod.value)) {
      delete pod.isFillRequired;
    }
  }

  onCancelChanges(){
    this.groupKeys = angular.copy(this.groupKeysCopy);
    this.onDataChange(this.groupKeys);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programPodView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./program-pod-view.html').default,
    controller: ProgramPodViewComponent
  });
